import type { Component } from 'vue';
import IconInput from './IconInput.vue';
import InputBack from './InputBack.vue';
import SearchInput from './SearchInput.vue';
import TextInput from './TextInput.vue';

export default new Map<string, Component>([
  ['SearchInput', SearchInput],
  ['IconInput', IconInput],
  ['TextInput', TextInput],
  ['InputBack', InputBack],
]);



